import { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import {
  createBrowserRouter,
  redirect,
  RouterProvider,
} from "react-router-dom";
import { WagmiProvider } from "wagmi";
import { config } from "../modernwallet/wagmi";

import "../shared/index.css";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import hljs from "highlight.js/lib/core";
import xml from "highlight.js/lib/languages/xml";

hljs.registerLanguage("xml", xml);

const queryClient = new QueryClient();

const loader = () => {
  if (!localStorage.getItem("user_id")) {
    return redirect("/login");
  }
  return null;
};

const reverseLoader = () => {
  if (localStorage.getItem("user_id")) {
    return redirect("/");
  }
  return null;
};

const router = createBrowserRouter([
  {
    path: "/",
    async lazy() {
      const { default: Component } = await import("../modernwallet/Root");
      return { Component, loader };
    },
  },
  {
    path: "/scan",
    async lazy() {
      const { default: Component } = await import("../modernwallet/Scan");
      return { Component, loader };
    },
  },
  {
    path: "/pay",
    async lazy() {
      const { default: Component } = await import("../modernwallet/Pay");
      return { Component, loader };
    },
  },
  {
    path: "/messages",
    async lazy() {
      const { default: Component } = await import("../modernwallet/Messages");
      return { Component, loader };
    },
  },
  {
    path: "/profile",
    async lazy() {
      const { default: Component } = await import("../modernwallet/Profile");
      return { Component, loader };
    },
  },
  {
    path: "/login",
    async lazy() {
      const { default: Component } = await import("../modernwallet/Login");
      return { Component, loader: reverseLoader };
    },
  },
]);

const appRoot = document.getElementById("app-root");

if (appRoot) {
  ReactDOM.createRoot(appRoot).render(
    <StrictMode>
      <WagmiProvider config={config}>
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={router} />
        </QueryClientProvider>
      </WagmiProvider>
    </StrictMode>,
  );
}
